import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { CommonPageOGCard, EOGType, ICommonPageOGCardProps } from '@lemon8/web-app-shared/ssr';
import { useDiscoverTitle } from '../shared/use-discover-title';
import { useDiscoverDescV2 } from '../shared/use-discover-desc';
import { useDiscoverCover } from '../shared/use-discover-cover';

export const DiscoverOpenGraph = () => {
  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: useAtomValue($PageLevelTraffic).canonicalUrl,
    ogTitle: useDiscoverTitle(),
    ogDescription: useDiscoverDescV2(),
    ogMediaMetaInfo: useDiscoverCover(),
    // Temperately set all card as OG Article type
    ogType: EOGType.Article,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
